"use client";

import React from "react";

const SealantMaintenance: React.FC = () => {
  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
      <h3 className="text-xl sm:text-2xl font-semibold text-gray-800">
        Maintenance: How to Keep Your Sealants Lasting Longer?
      </h3>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        Dental sealants are designed to last for several years, but their lifespan
        can vary depending on factors such as your oral hygiene habits, diet, and
        overall dental health. To help ensure that your sealants remain effective
        and durable, follow these maintenance tips:
      </p>
      <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg">
        {[
          <span key="1">
            <strong>Practice good oral hygiene:</strong> Brush your teeth at least
            twice a day with fluoride toothpaste, and floss daily to remove plaque
            and food debris from between your teeth.
          </span>,
          <span key="2">
            <strong>Avoid hard or sticky foods:</strong> Be mindful of what you
            eat, especially immediately after receiving sealants. Hard candies,
            chewy snacks, and ice can potentially damage the sealant material,
            reducing its effectiveness.
          </span>,
          <span key="3">
            <strong>Regular dental check-ups:</strong> Schedule regular
            appointments with your dentist for professional cleanings and
            examinations. During these visits, your dentist can assess the
            condition of your sealants and touch them up if necessary.
          </span>,
        ].map((item, idx) => (
          <li
            key={idx}
            className="group hover:bg-gray-50 transition-all duration-300 rounded-md py-1"
          >
            {item}
          </li>
        ))}
      </ul>
      <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
        By following these simple maintenance tips, you can help extend the life
        of your dental sealants and enjoy the benefits they provide for many years
        to come.
      </p>
    </div>
  );
};

export default SealantMaintenance;